import React from 'react';

export const ModalContext = React.createContext({
  currentlyDisplayedModal: undefined,
  presentModal: () => {},
  removeModal: () => {},
});
ModalContext.displayName = 'ModalContext';
